import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useSettingModal } from '../../../../hooks/Context';
import {AddClaim, AssignRole, CreateAdminUser, DisableAdmin, ViewDetails} from '../Modal';
import EachRow from './EachRow';
import css3 from '../../Applicants/css/applicant-table.module.css';
import { MdOutlineArrowBackIosNew as LBtn, MdOutlineArrowForwardIos as RBtn } from 'react-icons/md';
import { DropdownOption } from '../../../../customs/DropDownOption';
import { useSelector } from 'react-redux';
import {RootState} from '../../../../redux/store';
import apiCall from '../../../../utils/apiCall';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import AddSubordinateRole  from '../Modal/AddSubordinate';

interface RoleProps {
  Id: string;
  Name: string;
  NormalizedName: string;
}

interface RoleResponse {
  data: RoleProps[];
};

const AdminTable = (props:any) => {
    const [menuIndex, setMenuIndex] = useState<null | number>(null);
    const [pageArr, setPageArr] = useState<number[]>([]);
    const [activeData, setActiveData] = useState<number[]>([]);
    const [currentPage, setCurrentPage] = useState<any>(0);
    const [optionModal, setOptionModal] = useState<any>('');
    const [toggleModal, setToggleModal] = useState<number>(0);
    const {setShowModal, setModalContent} = useSettingModal();
    const [aData, setAData] = useState<any>([]);
    const [userD, setUserD] = useState<any>({});
    const [roleByUserData, setRoleByUserData] = useState<RoleProps[]>([]);

    const queryClient = useQueryClient();
    //const userId = useSelector((state: RootState) => state?.user?.userId);
    const data = props.data;
    const filter = props.filter;
    const roleData = props.roleData;

    const tableHead = ["First Name", "Surname", "Phone Number", "Email", "Role", ];

    const adminUserOptions = [
      "View Details",
      "Update Details",
      "Assign Role",
      "Remove Role",
      "Add Claim",
      "Remove Claim",
      "Add Subordinate",
      "Remove Subordinate",
      "Disable Admin"
    ];
 
    const onChange = (opt: string, user: any) => {
      setOptionModal(opt);
      setToggleModal(toggleModal + 1);
      setUserD(user);
    };
   
    const handlePrevious = () => {
      if(currentPage === 0){
          if(pageArr.length > 1){
              setCurrentPage(pageArr.at(-1))
              return false;
          }
          setCurrentPage(0);
          return false;
      }
      setCurrentPage(currentPage-1);
    };
 
    const handleNext = () => {
      if(pageArr.length > 1){
        if(currentPage === pageArr.at(-1)) {
            setCurrentPage(0);
            return false;
        }
        setCurrentPage(currentPage+1);
        return false;
      }
      setCurrentPage(0);
    }

    const DATA_PER_PAGE = 10;

  const getRoleByUserId = async () => {
    return (await (apiCall().post(`Authentication/GetRoleByUserId?userid=${userD?.UserId}`))) as RoleResponse;
  };

  const getRoleByUserIdMutation = useMutation(['get-roleById', userD?.UserId], getRoleByUserId, {
    retry: 0, 
    onSuccess: () => {
      queryClient.refetchQueries(['exam_approval'])
    }
  });

  const roleHandler = async () => {
    try {
      const data = (await getRoleByUserIdMutation.mutateAsync()).data;
      setRoleByUserData(data);
    } catch (error: any){

    }
  }

  useEffect(() => {
      roleHandler()
  }, [userD]);
  
  useEffect(() => {
    if(optionModal){
      if(optionModal === 'View Details') setModalContent(<ViewDetails data={userD} />);
      if(optionModal === 'Update Details') setModalContent(<CreateAdminUser mode={'update'} update={userD}/>);
      if(optionModal === 'Assign Role') setModalContent(<AssignRole data={userD} roleData={roleData} roleByUserData={roleByUserData}/>);
      if(optionModal === 'Add Claim') setModalContent(<AddClaim data={userD}/>);
      if(optionModal === 'Disable Admin') setModalContent(<DisableAdmin data={userD}/>);
      if(optionModal === 'Remove Role') setModalContent(<AssignRole data={userD} remove={true} roleData={roleData} roleByUserData={roleByUserData}/>);
      if(optionModal === 'Add Subordinate') setModalContent(<AddSubordinateRole data={userD} roleData={roleData} roleByUserIdData={roleByUserData}/>);
      if(optionModal === 'Remove Subordinate') setModalContent(<AddSubordinateRole data={userD} remove={true} roleData={roleData} roleByUserIdData={roleByUserData}/>);
      if(optionModal === 'Remove Claim') setModalContent(<AddClaim remove={true} data={userD}/>);
      setShowModal(true); 
    }
  }, [optionModal, toggleModal, roleByUserData])
 
    useEffect(() => {
       let arr: number[] = [];
       if(aData.length > 0) {
          let pNumber = Math.ceil(aData.length/DATA_PER_PAGE);
          let i;
          for(i = 0; i < pNumber; i++){
            arr.push(i);
          }
        } 
        
        setPageArr(arr);
        setCurrentPage(0);
    },[aData])
    
    useEffect(()=>{
      if(filter){
       let arr:any = [];
       data.forEach((eData:any,index:number) =>{
         if(eData.RoleName.toLowerCase().includes(filter.toLowerCase())){
           arr.push(eData)
         }
       })
       if(arr.length > 0) setAData(arr); 
     }
     else{
       setAData(data);
     }
    
     setCurrentPage(0);
   },[filter])
   useEffect(()=>{
     setAData(data);
  },[data])
 
  useEffect(()=>{
   if(aData && aData.length > 0){    
     let start = currentPage * DATA_PER_PAGE;
     let stop = start + DATA_PER_PAGE;
     setActiveData(aData.slice(start,stop));  
   }
 },[currentPage,aData])
 
 
  return <AdminTableContainer>
 
     <div>
       {tableHead.map((eSpan,index) => <span key={index}>{eSpan}</span>)}
     </div>
     <div style={{ position:"relative", zIndex:'1' }}>
       {activeData?.length > 0 && activeData.map((eUser:any, index:number) =>
         <EachRow key={index} index={index} 
         menuIndex={menuIndex} onClick={setMenuIndex}>
             <span>{eUser.FirstName}</span>
             <span>{eUser.LastName}</span>
             <span>{eUser.PhoneNumber}</span>
             <span>{eUser.Email}</span>
             <span>
               <div>{eUser.RoleList?.Roles[0]}</div>
               <DropdownOption user={eUser} onChange={onChange} options={adminUserOptions} index={index} menuIndex={menuIndex} setMenuIndex={setMenuIndex} />
             </span>
             {/* <span>
               <div style={{color:eUser.Status == 'Active'?'green':'red',}}>{eUser.Status}</div> 
               <DropdownOption user={eUser} onChange={onChange} options={adminUserOptions} index={index} menuIndex={menuIndex} setMenuIndex={setMenuIndex} />
             </span> */}
         </EachRow>
       )}
       
     </div>
     <div className={css3.pagination}>
         <div>
             <button className={`${css3.lBtn} ${css3.btn}`} onClick={handlePrevious}><LBtn/></button>
             {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

              if(index <= 2 && currentPage <= 2) return (<span
                  style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                  key={ePage} 
                  onClick={() => setCurrentPage(ePage)}
              >
                  {ePage + 1}
              </span>)  

              if(index == currentPage ) return (<span
                  style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                  key={ePage} 
                  onClick={() => setCurrentPage(ePage)}
              >
                  {ePage + 1}
              </span>)  

              if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
                  style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                  key={ePage} 
                  onClick={() => setCurrentPage(ePage)}
              >
                  {ePage + 1}
              </span>)  

              if(index == pageArr.length-1) return (
              <>
                  <>...</>
                  <span 
                  style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                  key={ePage} 
                  onClick={() => setCurrentPage(ePage)}
                  >
                      {ePage + 1}
                  </span>
              </>
              )  

              if(index == 0 ) return (
              <>
                  <span 
                  style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                  key={ePage} 
                  onClick={() => setCurrentPage(ePage)}
                  >
                      {ePage + 1}
                  </span>
                  <>...</>
              </>)  

              })} 
             <button className={`${css3.rBtn} ${css3.btn}`} onClick={handleNext}><RBtn/></button>
         </div>
     </div>
 
    </AdminTableContainer>
 }

 export default AdminTable;

 const AdminTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap:10px;
  margin-top:20px;

  & > div:first-child{
    display:grid;
    grid-template-columns: repeat(3, 1fr) 1.5fr repeat(1,1fr);
    border-bottom: 1px solid #E2E4E9;
  }
  & > div:first-child > span{
    padding:10px;
  }

  & > div:nth-child(2){
    width:100%;
    display: flex;
    flex-direction: column;
    row-gap:5px;
    min-height: 300px;
  }
  & > div:nth-child(2) > div{
    display:grid;
    grid-template-columns: repeat(3,1fr) 1.5fr repeat(1,1fr);
    border-left:3px solid #fff;
    cursor: pointer;
    font-size:13px;
  }
  & > div:nth-child(2) > div:hover{
    border-left-color:#293856;
    background-color:#E0FAEE;
  }

  & > div:nth-child(2) >div > span:not(:last-child){
    padding: 7px 10px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  & > div:nth-child(2) > div > span:last-child{
    display:flex;
    justify-content:space-between;
    padding:0 10px;
    align-items:center;
    position:relative;
    /* z-index: 1; */

  }
  & > div:nth-child(2) > div > span:last-child > span{
    /* position: relative;
    padding:8px;
    background-color:#11643C;
    color:#fff;
    height:20px; */
    display:none;
    /* align-items: center;
    justify-content: center;
    border-radius: 3px;
    width:30px; */
  }
  & > div:nth-child(2) > div:hover > span:last-child > span{
    display:flex;
  }
  /* & > div:nth-child(2) > div > span:last-child > span.active{
     display: flex !important;
  } */

`